import AbstractInstaller from "../../core/application/AbstractInstaller";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import FileAvailableCommand from "./controller/FileAvailableCommand";
import FileUnavailableCommand from "./controller/FileUnavailableCommand";
import FileModel from "./model/FileModel";
import FileExplorerItemFactory from "./controller/FileExplorerItemFactory";
import FileExplorerModel from "./model/FileExplorerModel";
import FileAssetLocator from "./controller/FileAssetLocator";

export default class FileInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("fileModel", FileModel, true);
        injector.mapClass('fileExplorerItemFactory', FileExplorerItemFactory, true);
        injector.mapClass('fileExplorerModel', FileExplorerModel, true);
        injector.mapClass('fileAssetLocator', FileAssetLocator, true);

        commands.add(ScenarioPlayerEvent.FILE_CONTENT_AVAILABLE, FileAvailableCommand);
        commands.add(ScenarioPlayerEvent.FILE_CONTENT_UNAVAILABLE, FileUnavailableCommand);
    }
}